import React, { useEffect, useState, useCallback } from 'react';
import { RootState } from 'reducer';
import DropdownSelect from 'seedly-component-library/dropdown-select';
import OpinionList from 'components/opinion/OpinionList';
import { getOpinions } from 'dispatcher/opinionDispatcher';
import { OPINION_FITLER } from 'constants/opinion';
import { useDispatch, useSelector } from 'react-redux';

const OpinionListWithSelect = () => {
  const dispatch = useDispatch();

  const filterItem = [
    {
      title: 'Recent',
      value: OPINION_FITLER.RECENT,
    },
    {
      title: 'Trending',
      value: OPINION_FITLER.TRENDING,
    },
  ];

  const currentPage = useSelector(
    (state: RootState) => state.opinion.pagination.currentPage,
  );
  const [selectedFilter, setSelected] = useState(filterItem[0].value);

  useEffect(() => {
    dispatch(getOpinions({ opinionFilter: selectedFilter }));
  }, [dispatch, selectedFilter]);

  // load more opinion
  const handleLoadMoreOpinion = useCallback(() => {
    dispatch(
      getOpinions({ opinionFilter: selectedFilter, page: currentPage + 1 }),
    );
  }, [dispatch, selectedFilter, currentPage]);

  return (
    <div className="flex flex-col gap-1 w-full">
      <DropdownSelect
        items={filterItem}
        defaultSelectedItem={filterItem[0]}
        handleSelectedItemchange={item => {
          setSelected(item.selectedItem.value);
        }}
      />
      <OpinionList handleLoadMoreOpinion={handleLoadMoreOpinion} />
    </div>
  );
};

export default OpinionListWithSelect;
